/* eslint-disable react/no-unused-prop-types */
import React, { memo } from 'react'
import { array, func } from 'prop-types'
import { Container, Row, Col, HeadingText } from '@paypalcorp/pp-react'
import DWSubSection from './dw-sub-section'

const DWSections = memo(({ sections = [], onSectionClick }) =>
  sections.map(
    ({
      sectionId,
      sectionName,
      hasElmoTreatment,
      subSections = [],
      isEnabled,
    }) =>
      isEnabled &&
      hasElmoTreatment && (
        <Container
          fluid
          id={sectionId}
          key={sectionName}
          className="dw-section-container"
        >
          <Row align="center" noGutters>
            <Col xs={12} sm={8}>
              <HeadingText
                id={`${sectionId}Header`}
                size="sm"
                className="dw-section-header"
              >
                {sectionName}
              </HeadingText>
            </Col>
          </Row>
          {subSections.map(
            (subSection, index) =>
              subSection.featureEnabled &&
              subSection.hasElmoTreatment && (
                <DWSubSection
                  key={`dw-sub-section-${index}`}
                  onSectionClick={onSectionClick}
                  {...subSection}
                />
              ),
          )}
        </Container>
      ),
  ),
)

DWSections.propTypes = {
  sections: array,
  onSectionClick: func.isRequired,
}

DWSections.defaultProps = {
  sections: [],
}

DWSections.displayName = 'DWSections'

export default DWSections
